import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { CustomFilterProps, useGridFilter } from 'ag-grid-react';
import {
  IAfterGuiAttachedParams,
  IDoesFilterPassParams,
} from 'ag-grid-community';
import { filterStyles } from './styles';
import { PriceTypeEnum } from 'components/marketplace-listing/listing-form-schema';

export default ({
  model,
  onModelChange,
  getValue,
  ...rest
}: CustomFilterProps) => {
  const [closeFilter, setCloseFilter] = useState<(() => void) | undefined>();
  const [unappliedModel, setUnappliedModel] = useState(model);

  const doesFilterPass = useCallback(
    (params: IDoesFilterPassParams) => {
      const filterText: string = model;
      const price_key: string =
        params.data.prices_label === 'POA'
          ? 'POA'
          : (Object.keys(params.data.prices)[0] as string);

      switch (filterText) {
        case PriceTypeEnum.HSCW:
        case PriceTypeEnum.LIVEWEIGHT:
        case PriceTypeEnum.PER_HEAD:
        case 'POA':
          return price_key === filterText;
        default:
          return true;
      }
    },
    [model]
  );

  const afterGuiAttached = useCallback(
    ({ hidePopup }: IAfterGuiAttachedParams) => {
      setCloseFilter(() => hidePopup);
    },
    []
  );

  // register filter handlers with the grid
  useGridFilter({
    doesFilterPass,
    afterGuiAttached,
  });

  useEffect(() => {
    setUnappliedModel(model);
  }, [model]);

  const onPriceTypeChange = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    onModelChange(value === 'All' ? null : value);
    if (closeFilter) {
      closeFilter();
    }
  };

  return (
    <div style={filterStyles.container}>
      <div>Select Product</div>
      <label>
        <input
          type='radio'
          name='price_type'
          value='All'
          checked={unappliedModel === null}
          onChange={onPriceTypeChange}
        />{' '}
        All
      </label>
      <label>
        <input
          type='radio'
          name='price_type'
          value='HSCW'
          checked={unappliedModel === 'HSCW'}
          onChange={onPriceTypeChange}
        />{' '}
        HSCW
      </label>
      <label>
        <input
          type='radio'
          name='price_type'
          value='PER_HEAD'
          checked={unappliedModel === 'PER_HEAD'}
          onChange={onPriceTypeChange}
        />{' '}
        Head
      </label>
      <label>
        <input
          type='radio'
          name='price_type'
          value='LIVEWEIGHT'
          checked={unappliedModel === 'LIVEWEIGHT'}
          onChange={onPriceTypeChange}
        />{' '}
        Liveweight
      </label>
      <label>
        <input
          type='radio'
          name='price_type'
          value='POA'
          checked={unappliedModel === 'POA'}
          onChange={onPriceTypeChange}
        />{' '}
        POA
      </label>
    </div>
  );
};
